module.exports = __webpack_public_path__ + "static/ackee_logo_black-72442977d6deff35195dfc3136a27a48.svg";